import { render, staticRenderFns } from "./corn.vue?vue&type=template&id=074ab6fe"
import script from "./corn.vue?vue&type=script&lang=js"
export * from "./corn.vue?vue&type=script&lang=js"
import style0 from "./corn.vue?vue&type=style&index=0&id=074ab6fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports